<script>
	import { playlist } from './constants';

	import Play from './Play.svelte';
	import Pause from './Pause.svelte';
	import NextIcon from './Next.svelte';
	import Icon from './Icon.svelte';

	let isPlay = false;
	let currentTrack = new Audio(`audio/${playlist[0]}`);
	let currentTrackIndex = 0;
	let isMusicControlsVisible = false;

	currentTrack.addEventListener('ended', () => {
		nextTrack();
	});

	function toggleControls() {
		currentTrack.pause();
		isPlay = false;
		isMusicControlsVisible = !isMusicControlsVisible;
	}

	function switchPlay() {
		isPlay = !isPlay;

		if (isPlay) {
			currentTrack.play();
		} else {
			currentTrack.pause();
		}
	}

	function nextTrack() {
		currentTrack.pause();

		if (currentTrackIndex + 1 > playlist.length - 1) {
			currentTrack = new Audio(`audio/${playlist[0]}`);
			currentTrackIndex = 0;
		} else {
			currentTrackIndex += 1;
			currentTrack = new Audio(`audio/${playlist[currentTrackIndex]}`);
		}

		currentTrack.addEventListener('ended', () => {
			nextTrack();
		});
		isPlay = true;
		currentTrack.play();
	}
</script>

<div class="equalizer">
	<div class="header" on:click={toggleControls}>
		{isMusicControlsVisible ? 'Disable audio' : 'Enable audio'}
	</div>

	{#if isMusicControlsVisible}
		<div class="music-controls">
			{#if isPlay}
				<Icon
					width="28"
					height="28"
					color="#fff"
					name="pause"
					on:click={switchPlay}><Pause /></Icon
				>
			{:else}
				<Icon
					width="28"
					height="28"
					color="#fff"
					name="play"
					on:click={switchPlay}><Play /></Icon
				>
			{/if}

			<Icon
				width="28"
				height="28"
				color="#fff"
				name="next"
				on:click={nextTrack}
			>
				<NextIcon />
			</Icon>
		</div>
	{/if}

	<div class="vizualizator">
		<div class={`item ${isPlay ? 'first' : ''}`} />
		<div class={`item ${isPlay ? 'second' : ''}`} />
		<div class={`item ${isPlay ? 'third' : ''}`} />
	</div>
</div>

<style>
	.equalizer {
		position: absolute;
		left: 30px;
		bottom: 20px;
		cursor: pointer;
		font-size: 16px;
	}

	.header {
		margin-bottom: 10px;
		letter-spacing: 3px;
		font-size: 12px;
		text-align: left;
	}

	.music-controls {
		min-width: 125px;
		margin-bottom: 10px;
		text-align: left;
	}

	.vizualizator {
		width: 100%;
		margin: 0 auto;
	}

	.item {
		width: 60px;
		height: 2px;
		margin-bottom: 10px;
		border-radius: 50%;
		transition: all 0.5s;
		background-color: #fff;
	}

	.first {
		animation: equa 2s infinite ease;
	}

	.second {
		animation: equa 1s infinite ease;
	}

	.third {
		animation: equa 1.5s infinite ease;
	}

	@keyframes equa {
		0% {
			width: 60px;
		}
		25% {
			width: 50px;
		}
		50% {
			width: 40px;
		}
		75% {
			width: 50px;
		}
		100% {
			width: 60px;
		}
	}

	@media (max-width: 1024px) {
		.equalizer {
			left: 5px;
			bottom: 5px;
		}
	}

	@media (max-width: 768px) and (max-height: 320px) {
		.vizualizator {
			display: none;
		}
	}

	@media (max-width: 768px) {
		.equalizer {
			left: 5px;
			bottom: 5px;
			font-size: 12px;
		}
	}

	@media (max-width: 320px) and (orientation: portrait) {
		.header {
			font-size: 10px;
		}
	}
</style>
